import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Query } from 'react-apollo';
import gql from 'graphql-tag';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';

import { withAccount } from '../../components/AccountContext';
import JobProfileList from './JobProfileList';
import { parse, filterPaginationWithSize, emptyConnection } from '../../utils/UrlUtil';

export const LIST_QUERY = gql`
  query(
    $accountId: ID!
    $first: Int
    $after: String
    $last: Int
    $before: String
    $filter: JobProfileFilter
    $sort: JobProfileSortSpecifier
  ) {
    account(id: $accountId) {
      id
      jobProfiles(first: $first, after: $after, last: $last, before: $before, filter: $filter, sort: $sort) {
        indexFrom
        indexTo
        totalCount
        edges {
          node {
            id
            name
            createdOn
            updatedOn
            assessmentTemplate {
              id
              title
            }
            jpsInfo {
              submittedJps
              totalJps
            }
            createdBy {
              id
              firstName
              lastName
            }
          }
        }
        pageInfo {
          startCursor
          endCursor
          hasPreviousPage
          hasNextPage
        }
      }
    }
  }
`;

class JobProfileListContainer extends Component {
  render() {
    const { currentAccount, location } = this.props;
    const params = parse(location.search);
    const pagination = filterPaginationWithSize(params);
    const variables = {
      ...pagination,
      accountId: currentAccount,
      sort: params.sort || { sortBy: 'createdOn', sortDir: 'DESC' },
      filter: params.filter,
    };
    return (
      <Query query={LIST_QUERY} variables={variables} fetchPolicy="network-only">
        {({ data, loading, error }) => {
          if (error) return `Error! ${error.message}`;

          const connection = data && data.account ? data.account.jobProfiles : emptyConnection();

          return <JobProfileList connection={connection} currentAccount={currentAccount} loading={loading} />;
        }}
      </Query>
    );
  }
}

JobProfileListContainer.propTypes = {
  location: PropTypes.objectOf(PropTypes.any).isRequired,
  currentAccount: PropTypes.string.isRequired,
};

export default withRouter(injectIntl(withAccount(JobProfileListContainer)));
